"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brandIconLarge = exports.brandIconSmall = exports.brandIconBase = void 0;

var _stylitas = require("@creditas/stylitas");

const brandIconBase = ({
  theme,
  color
}) => (0, _stylitas.css)`
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: ${_stylitas.utilities.palette.color(theme, color)};
  flex-shrink: 0;
  font-size: 96px;
`;

exports.brandIconBase = brandIconBase;

const brandIconSmall = ({
  fontSize
}) => fontSize === 'small' && (0, _stylitas.css)`
    font-size: 72px;
  `;

exports.brandIconSmall = brandIconSmall;

const brandIconLarge = ({
  fontSize
}) => fontSize === 'large' && (0, _stylitas.css)`
    font-size: 144px;
  `;

exports.brandIconLarge = brandIconLarge;